import { useEffect, useState } from 'react';
import { registryApi } from '@/features/publicsite/registry/api/registryApi';
import type { AdvisorCoverage } from '@/features/publicsite/types/registry/AdvisorCoverage';

/** The registry's territorial coverage, loaded once; null until it arrives. */
export function useAdvisorCoverage(): AdvisorCoverage | null {
  const [coverage, setCoverage] = useState<AdvisorCoverage | null>(null);

  useEffect(() => {
    let live = true;
    registryApi.coverage().then((c) => {
      if (live) setCoverage(c);
    });
    return () => {
      live = false;
    };
  }, []);

  return coverage;
}
